const countryPhoneCodes = [
  { country: "Afghanistan", code: "+93", shopifyCode: "AF" },
  { country: "\xC5land Islands", code: "+358", shopifyCode: "AX" },
  { country: "Albania", code: "+355", shopifyCode: "AL" },
  { country: "Algeria", code: "+213", shopifyCode: "DZ" },
  { country: "Andorra", code: "+376", shopifyCode: "AD" },
  { country: "Angola", code: "+244", shopifyCode: "AO" },
  { country: "Anguilla", code: "+1-264", shopifyCode: "AI" },
  { country: "Antigua & Barbuda", code: "+1-268", shopifyCode: "AG" },
  { country: "Argentina", code: "+54", shopifyCode: "AR" },
  { country: "Armenia", code: "+374", shopifyCode: "AM" },
  { country: "Aruba", code: "+297", shopifyCode: "AW" },
  { country: "Ascension Island", code: "+247", shopifyCode: "AC" },
  { country: "Australia", code: "+61", shopifyCode: "AU" },
  { country: "Austria", code: "+43", shopifyCode: "AT" },
  { country: "Azerbaijan", code: "+994", shopifyCode: "AZ" },
  { country: "Bahamas", code: "+1-242", shopifyCode: "BS" },
  { country: "Bahrain", code: "+973", shopifyCode: "BH" },
  { country: "Bangladesh", code: "+880", shopifyCode: "BD" },
  { country: "Barbados", code: "+1-246", shopifyCode: "BB" },
  { country: "Belarus", code: "+375", shopifyCode: "BY" },
  { country: "Belgium", code: "+32", shopifyCode: "BE" },
  { country: "Belize", code: "+501", shopifyCode: "BZ" },
  { country: "Benin", code: "+229", shopifyCode: "BJ" },
  { country: "Bermuda", code: "+1-441", shopifyCode: "BM" },
  { country: "Bhutan", code: "+975", shopifyCode: "BT" },
  { country: "Bolivia", code: "+591", shopifyCode: "BO" },
  { country: "Bosnia & Herzegovina", code: "+387", shopifyCode: "BA" },
  { country: "Botswana", code: "+267", shopifyCode: "BW" },
  { country: "Brazil", code: "+55", shopifyCode: "BR" },
  {
    country: "British Indian Ocean Territory",
    code: "+246",
    shopifyCode: "IO",
  },
  { country: "British Virgin Islands", code: "+1-284", shopifyCode: "VG" },
  { country: "Brunei", code: "+673", shopifyCode: "BN" },
  { country: "Bulgaria", code: "+359", shopifyCode: "BG" },
  { country: "Burkina Faso", code: "+226", shopifyCode: "BF" },
  { country: "Burundi", code: "+257", shopifyCode: "BI" },
  { country: "Cambodia", code: "+855", shopifyCode: "KH" },
  { country: "Cameroon", code: "+237", shopifyCode: "CM" },
  { country: "Canada", code: "+1", shopifyCode: "CA" },
  { country: "Cape Verde", code: "+238", shopifyCode: "CV" },
  { country: "Caribbean Netherlands", code: "+599", shopifyCode: "BQ" },
  { country: "Cayman Islands", code: "+1-345", shopifyCode: "KY" },
  { country: "Central African Republic", code: "+236", shopifyCode: "CF" },
  { country: "Chad", code: "+235", shopifyCode: "TD" },
  { country: "Chile", code: "+56", shopifyCode: "CL" },
  { country: "China", code: "+86", shopifyCode: "CN" },
  { country: "Christmas Island", code: "+61", shopifyCode: "CX" },
  { country: "Cocos (Keeling) Islands", code: "+61", shopifyCode: "CC" },
  { country: "Colombia", code: "+57", shopifyCode: "CO" },
  { country: "Comoros", code: "+269", shopifyCode: "KM" },
  { country: "Congo - Brazzaville", code: "+242", shopifyCode: "CG" },
  { country: "Congo - Kinshasa", code: "+243", shopifyCode: "CD" },
  { country: "Cook Islands", code: "+682", shopifyCode: "CK" },
  { country: "Costa Rica", code: "+506", shopifyCode: "CR" },
  { country: "Croatia", code: "+385", shopifyCode: "HR" },
  { country: "Cura\xE7ao", code: "+599", shopifyCode: "CW" },
  { country: "Cyprus", code: "+357", shopifyCode: "CY" },
  { country: "Czechia", code: "+420", shopifyCode: "CZ" },
  { country: "C\xF4te d\u2019Ivoire", code: "+225", shopifyCode: "CI" },
  { country: "Denmark", code: "+45", shopifyCode: "DK" },
  { country: "Djibouti", code: "+253", shopifyCode: "DJ" },
  { country: "Dominica", code: "+1-767", shopifyCode: "DM" },
  { country: "Dominican Republic", code: "+1-809", shopifyCode: "DO" },
  { country: "Ecuador", code: "+593", shopifyCode: "EC" },
  { country: "Egypt", code: "+20", shopifyCode: "EG" },
  { country: "El Salvador", code: "+503", shopifyCode: "SV" },
  { country: "Equatorial Guinea", code: "+240", shopifyCode: "GQ" },
  { country: "Eritrea", code: "+291", shopifyCode: "ER" },
  { country: "Estonia", code: "+372", shopifyCode: "EE" },
  { country: "Eswatini", code: "+268", shopifyCode: "SZ" },
  { country: "Ethiopia", code: "+251", shopifyCode: "ET" },
  { country: "Falkland Islands", code: "+500", shopifyCode: "FK" },
  { country: "Faroe Islands", code: "+298", shopifyCode: "FO" },
  { country: "Fiji", code: "+679", shopifyCode: "FJ" },
  { country: "Finland", code: "+358", shopifyCode: "FI" },
  { country: "France", code: "+33", shopifyCode: "FR" },
  { country: "French Guiana", code: "+594", shopifyCode: "GF" },
  { country: "French Polynesia", code: "+689", shopifyCode: "PF" },
  { country: "French Southern Territories", code: "+262", shopifyCode: "TF" },
  { country: "Gabon", code: "+241", shopifyCode: "GA" },
  { country: "Gambia", code: "+220", shopifyCode: "GM" },
  { country: "Georgia", code: "+995", shopifyCode: "GE" },
  { country: "Germany", code: "+49", shopifyCode: "DE" },
  { country: "Ghana", code: "+233", shopifyCode: "GH" },
  { country: "Gibraltar", code: "+350", shopifyCode: "GI" },
  { country: "Greece", code: "+30", shopifyCode: "GR" },
  { country: "Greenland", code: "+299", shopifyCode: "GL" },
  { country: "Grenada", code: "+1-473", shopifyCode: "GD" },
  { country: "Guadeloupe", code: "+590", shopifyCode: "GP" },
  { country: "Guatemala", code: "+502", shopifyCode: "GT" },
  { country: "Guernsey", code: "+44", shopifyCode: "GG" },
  { country: "Guinea", code: "+224", shopifyCode: "GN" },
  { country: "Guinea-Bissau", code: "+245", shopifyCode: "GW" },
  { country: "Guyana", code: "+592", shopifyCode: "GY" },
  { country: "Haiti", code: "+509", shopifyCode: "HT" },
  { country: "Honduras", code: "+504", shopifyCode: "HN" },
  { country: "Hong Kong SAR", code: "+852", shopifyCode: "HK" },
  { country: "Hungary", code: "+36", shopifyCode: "HU" },
  { country: "Iceland", code: "+354", shopifyCode: "IS" },
  { country: "India", code: "+91", shopifyCode: "IN" },
  { country: "Indonesia", code: "+62", shopifyCode: "ID" },
  { country: "Iraq", code: "+964", shopifyCode: "IQ" },
  { country: "Ireland", code: "+353", shopifyCode: "IE" },
  { country: "Isle of Man", code: "+44", shopifyCode: "IM" },
  { country: "Israel", code: "+972", shopifyCode: "IL" },
  { country: "Italy", code: "+39", shopifyCode: "IT" },
  { country: "Jamaica", code: "+1-876", shopifyCode: "JM" },
  { country: "Japan", code: "+81", shopifyCode: "JP" },
  { country: "Jersey", code: "+44", shopifyCode: "JE" },
  { country: "Jordan", code: "+962", shopifyCode: "JO" },
  { country: "Kazakhstan", code: "+7", shopifyCode: "KZ" },
  { country: "Kenya", code: "+254", shopifyCode: "KE" },
  { country: "Kiribati", code: "+686", shopifyCode: "KI" },
  { country: "Kosovo", code: "+383", shopifyCode: "XK" },
  { country: "Kuwait", code: "+965", shopifyCode: "KW" },
  { country: "Kyrgyzstan", code: "+996", shopifyCode: "KG" },
  { country: "Laos", code: "+856", shopifyCode: "LA" },
  { country: "Latvia", code: "+371", shopifyCode: "LV" },
  { country: "Lebanon", code: "+961", shopifyCode: "LB" },
  { country: "Lesotho", code: "+266", shopifyCode: "LS" },
  { country: "Liberia", code: "+231", shopifyCode: "LR" },
  { country: "Libya", code: "+218", shopifyCode: "LY" },
  { country: "Liechtenstein", code: "+423", shopifyCode: "LI" },
  { country: "Lithuania", code: "+370", shopifyCode: "LT" },
  { country: "Luxembourg", code: "+352", shopifyCode: "LU" },
  { country: "Macao SAR", code: "+853", shopifyCode: "MO" },
  { country: "Madagascar", code: "+261", shopifyCode: "MG" },
  { country: "Malawi", code: "+265", shopifyCode: "MW" },
  { country: "Malaysia", code: "+60", shopifyCode: "MY" },
  { country: "Maldives", code: "+960", shopifyCode: "MV" },
  { country: "Mali", code: "+223", shopifyCode: "ML" },
  { country: "Malta", code: "+356", shopifyCode: "MT" },
  { country: "Martinique", code: "+596", shopifyCode: "MQ" },
  { country: "Mauritania", code: "+222", shopifyCode: "MR" },
  { country: "Mauritius", code: "+230", shopifyCode: "MU" },
  { country: "Mayotte", code: "+262", shopifyCode: "YT" },
  { country: "Mexico", code: "+52", shopifyCode: "MX" },
  { country: "Moldova", code: "+373", shopifyCode: "MD" },
  { country: "Monaco", code: "+377", shopifyCode: "MC" },
  { country: "Mongolia", code: "+976", shopifyCode: "MN" },
  { country: "Montenegro", code: "+382", shopifyCode: "ME" },
  { country: "Montserrat", code: "+1-664", shopifyCode: "MS" },
  { country: "Morocco", code: "+212", shopifyCode: "MA" },
  { country: "Mozambique", code: "+258", shopifyCode: "MZ" },
  { country: "Myanmar (Burma)", code: "+95", shopifyCode: "MM" },
  { country: "Namibia", code: "+264", shopifyCode: "NA" },
  { country: "Nauru", code: "+674", shopifyCode: "NR" },
  { country: "Nepal", code: "+977", shopifyCode: "NP" },
  { country: "Netherlands", code: "+31", shopifyCode: "NL" },
  { country: "New Caledonia", code: "+687", shopifyCode: "NC" },
  { country: "New Zealand", code: "+64", shopifyCode: "NZ" },
  { country: "Nicaragua", code: "+505", shopifyCode: "NI" },
  { country: "Niger", code: "+227", shopifyCode: "NE" },
  { country: "Nigeria", code: "+234", shopifyCode: "NG" },
  { country: "Niue", code: "+683", shopifyCode: "NU" },
  { country: "Norfolk Island", code: "+672", shopifyCode: "NF" },
  { country: "North Macedonia", code: "+389", shopifyCode: "MK" },
  { country: "Norway", code: "+47", shopifyCode: "NO" },
  { country: "Oman", code: "+968", shopifyCode: "OM" },
  { country: "Pakistan", code: "+92", shopifyCode: "PK" },
  { country: "Palestinian Territories", code: "+970", shopifyCode: "PS" },
  { country: "Panama", code: "+507", shopifyCode: "PA" },
  { country: "Papua New Guinea", code: "+675", shopifyCode: "PG" },
  { country: "Paraguay", code: "+595", shopifyCode: "PY" },
  { country: "Peru", code: "+51", shopifyCode: "PE" },
  { country: "Philippines", code: "+63", shopifyCode: "PH" },
  { country: "Pitcairn Islands", code: "+64", shopifyCode: "PN" },
  { country: "Poland", code: "+48", shopifyCode: "PL" },
  { country: "Portugal", code: "+351", shopifyCode: "PT" },
  { country: "Qatar", code: "+974", shopifyCode: "QA" },
  { country: "R\xE9union", code: "+262", shopifyCode: "RE" },
  { country: "Romania", code: "+40", shopifyCode: "RO" },
  { country: "Russia", code: "+7", shopifyCode: "RU" },
  { country: "Rwanda", code: "+250", shopifyCode: "RW" },
  { country: "Samoa", code: "+685", shopifyCode: "WS" },
  { country: "San Marino", code: "+378", shopifyCode: "SM" },
  { country: "S\xE3o Tom\xE9 & Pr\xEDncipe", code: "+239", shopifyCode: "ST" },
  { country: "Saudi Arabia", code: "+966", shopifyCode: "SA" },
  { country: "Senegal", code: "+221", shopifyCode: "SN" },
  { country: "Serbia", code: "+381", shopifyCode: "RS" },
  { country: "Seychelles", code: "+248", shopifyCode: "SC" },
  { country: "Sierra Leone", code: "+232", shopifyCode: "SL" },
  { country: "Singapore", code: "+65", shopifyCode: "SG" },
  { country: "Sint Maarten", code: "+1-721", shopifyCode: "SX" },
  { country: "Slovakia", code: "+421", shopifyCode: "SK" },
  { country: "Slovenia", code: "+386", shopifyCode: "SI" },
  { country: "Solomon Islands", code: "+677", shopifyCode: "SB" },
  { country: "Somalia", code: "+252", shopifyCode: "SO" },
  { country: "South Africa", code: "+27", shopifyCode: "ZA" },
  {
    country: "South Georgia & South Sandwich Islands",
    code: "+500",
    shopifyCode: "GS",
  },
  { country: "South Korea", code: "+82", shopifyCode: "KR" },
  { country: "South Sudan", code: "+211", shopifyCode: "SS" },
  { country: "Spain", code: "+34", shopifyCode: "ES" },
  { country: "Sri Lanka", code: "+94", shopifyCode: "LK" },
  { country: "St. Barth\xE9lemy", code: "+590", shopifyCode: "BL" },
  { country: "St. Helena", code: "+290", shopifyCode: "SH" },
  { country: "St. Kitts & Nevis", code: "+1-869", shopifyCode: "KN" },
  { country: "St. Lucia", code: "+1-758", shopifyCode: "LC" },
  { country: "St. Martin", code: "+590", shopifyCode: "MF" },
  { country: "St. Pierre & Miquelon", code: "+508", shopifyCode: "PM" },
  { country: "St. Vincent & Grenadines", code: "+1-784", shopifyCode: "VC" },
  { country: "Sudan", code: "+249", shopifyCode: "SD" },
  { country: "Suriname", code: "+597", shopifyCode: "SR" },
  { country: "Svalbard & Jan Mayen", code: "+47", shopifyCode: "SJ" },
  { country: "Sweden", code: "+46", shopifyCode: "SE" },
  { country: "Switzerland", code: "+41", shopifyCode: "CH" },
  { country: "Syria", code: "+963", shopifyCode: "SY" },
  { country: "Taiwan", code: "+886", shopifyCode: "TW" },
  { country: "Tajikistan", code: "+992", shopifyCode: "TJ" },
  { country: "Tanzania", code: "+255", shopifyCode: "TZ" },
  { country: "Thailand", code: "+66", shopifyCode: "TH" },
  { country: "Timor-Leste", code: "+670", shopifyCode: "TL" },
  { country: "Togo", code: "+228", shopifyCode: "TG" },
  { country: "Tokelau", code: "+690", shopifyCode: "TK" },
  { country: "Tonga", code: "+676", shopifyCode: "TO" },
  { country: "Trinidad & Tobago", code: "+1-868", shopifyCode: "TT" },
  { country: "Tunisia", code: "+216", shopifyCode: "TN" },
  { country: "Turkey", code: "+90", shopifyCode: "TR" },
  { country: "Turkmenistan", code: "+993", shopifyCode: "TM" },
  { country: "Turks & Caicos Islands", code: "+1-649", shopifyCode: "TC" },
  { country: "Tuvalu", code: "+688", shopifyCode: "TV" },
  { country: "Uganda", code: "+256", shopifyCode: "UG" },
  { country: "Ukraine", code: "+380", shopifyCode: "UA" },
  { country: "United Arab Emirates", code: "+971", shopifyCode: "AE" },
  { country: "United Kingdom", code: "+44", shopifyCode: "GB" },
  { country: "United States", code: "+1", shopifyCode: "US" },
  { country: "Uruguay", code: "+598", shopifyCode: "UY" },
  { country: "Uzbekistan", code: "+998", shopifyCode: "UZ" },
  { country: "Vanuatu", code: "+678", shopifyCode: "VU" },
  { country: "Vatican City", code: "+39", shopifyCode: "VA" },
  { country: "Venezuela", code: "+58", shopifyCode: "VE" },
  { country: "Vietnam", code: "+84", shopifyCode: "VN" },
  { country: "Wallis & Futuna", code: "+681", shopifyCode: "WF" },
  { country: "Western Sahara", code: "+212", shopifyCode: "EH" },
  { country: "Yemen", code: "+967", shopifyCode: "YE" },
  { country: "Zambia", code: "+260", shopifyCode: "ZM" },
  { country: "Zimbabwe", code: "+263", shopifyCode: "ZW" },
];
